import "./ProductOptionsSection.css";

function ProductOptionsSection({
  formData,
  updateField,
}) {
  return (
    <div className="bakery-form-section">

      <h3 className="section-title">
        Product Options
      </h3>

      <div className="bakery-form-grid">

        <div className="form-group">
          <label>Flavour</label>

          <select
            value={formData.flavour}
            onChange={(e) =>
              updateField("flavour", e.target.value)
            }
          >
            <option value="">Select Flavour</option>
            <option value="Chocolate">Chocolate</option>
            <option value="Vanilla">Vanilla</option>
            <option value="Black Forest">Black Forest</option>
            <option value="White Forest">White Forest</option>
            <option value="Red Velvet">Red Velvet</option>
            <option value="Butterscotch">Butterscotch</option>
            <option value="Strawberry">Strawberry</option>
            <option value="Pineapple">Pineapple</option>
            <option value="Mango">Mango</option>
            <option value="Blueberry">Blueberry</option>
            <option value="Mixed Fruit">Mixed Fruit</option>
            <option value="Coffee">Coffee</option>
            <option value="Custom">Custom</option>
          </select>
        </div>

        <div className="form-group">
          <label>Egg Type</label>

          <select
            value={formData.eggType}
            onChange={(e) =>
              updateField("eggType", e.target.value)
            }
          >
            <option value="Eggless">Eggless</option>
            <option value="Egg">Egg</option>
          </select>
        </div>

      </div>

      <div className="checkbox-grid">

        <label className="checkbox-item">
          <input
            type="checkbox"
            checked={formData.customCake}
            onChange={(e) =>
              updateField("customCake", e.target.checked)
            }
          />

          <span>Custom Cake Available</span>
        </label>

        <label className="checkbox-item">
          <input
            type="checkbox"
            checked={formData.advanceOrder}
            onChange={(e) =>
              updateField("advanceOrder", e.target.checked)
            }
          />

          <span>Advance Order Required</span>
        </label>

        <label className="checkbox-item">
          <input
            type="checkbox"
            checked={formData.isBestSeller}
            onChange={(e) =>
              updateField("isBestSeller", e.target.checked)
            }
          />

          <span>Best Seller</span>
        </label>

      </div>

    </div>
  );
}

export default ProductOptionsSection;